import { Star } from "lucide-react";

export default function Stars({ size = 13, rating = 5, showValue = false }) {
  return (
    <span className="inline-flex items-center gap-1.5" role="img" aria-label={`Rated ${rating} out of 5 stars`} data-testid="star-rating">
      <span className="inline-flex gap-0.5">
        {[0, 1, 2, 3, 4].map((i) => {
          const fill = Math.max(0, Math.min(1, rating - i)) * 100;
          return (
            <span key={i} className="relative inline-block" style={{ width: size, height: size }}>
              <Star size={size} className="absolute inset-0 text-ink/15 fill-ink/10" />
              <span className="absolute inset-0 overflow-hidden" style={{ width: `${fill}%` }}>
                <Star size={size} className="fill-gold text-gold" />
              </span>
            </span>
          );
        })}
      </span>
      {showValue && <span className="text-xs font-bold text-ink/70">{rating.toFixed(1)}</span>}
    </span>
  );
}
